export const borderStyleConstants = {
    ROUNDED: 'ROUNDED',
    RECTANGULAR: 'RECTANGULAR'
}